import { LayoutHOC } from "base/ui/layout/layout";
import { createMachineStatus } from "./machineStatus";



export const createMachineStatusPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createMachineStatus());
};